class EditorialCollections extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.editorial-collections__item');
    this.images = this.querySelectorAll('.editorial-collections__image');
    this.bodyEl = this.querySelector('.editorial-collections__body');
    this.linkEl = this.querySelector('.editorial-collections__link');
  }

  connectedCallback() {
    if (!this.items.length || !this.images.length) return;

    this.items.forEach(item => {
      item.addEventListener('mouseenter', () => this.updateFromItem(item));
      item.addEventListener('click', () => this.updateFromItem(item));
      item.addEventListener('focus', () => this.updateFromItem(item));
    });

    this.centerFirstItem();
  }

  centerFirstItem() {
    const firstItem = this.items[0];
    if (!firstItem) return;

    const slider = firstItem.parentElement;
    if (!slider) return;

    requestAnimationFrame(() => {
      const offset = Math.abs(
        firstItem.offsetLeft +
        firstItem.offsetWidth / 2 -
        slider.clientWidth / 2
      );

      slider.style.paddingInline = offset + 'px';
    });
  }

  updateFromItem(item) {
    const index = item.dataset.index;
    const body = item.dataset.body;
    const linkLabel = item.dataset.linkLabel;
    const linkUrl = item.dataset.linkUrl;

    this.images.forEach(img => img.classList.remove('is-active'));
    const img = this.querySelector(
      `.editorial-collections__image[data-image-index="${index}"]`
    );
    if (img) img.classList.add('is-active');

    this.bodyEl.textContent = body;

    if (linkLabel != '' && linkUrl != '') {
      this.linkEl.style.display = '';
      this.linkEl.textContent = linkLabel;
      this.linkEl.href = linkUrl;
    } else {
      this.linkEl.style.display = 'none';
    }

    this.items.forEach(i => i.classList.remove('is-active'));
    item.classList.add('is-active');
  }
}

if (!customElements.get('editorial-collections')) {
  customElements.define('editorial-collections', EditorialCollections);
}